import { EmployeeRole } from '../models/employee.model';
import { LoginResponse } from '../services/auth.service';

// Menu items structure (should match main-layout.component.tsx)
const getMenuItems = (onRoles: (roles: EmployeeRole[]) => boolean) => [
    {
        default: true,
        visible: onRoles([]),
        text: 'New Proforma',
        path: '/proforma'
    },
    {
        visible: onRoles([]),
        text: 'My Proformas',
        path: '/my-proformas'
    },
    {
        visible: onRoles([EmployeeRole.MANAGING_DIRECTOR, EmployeeRole.PAYMENT_APPROVER, EmployeeRole.ACCOUNTANT, EmployeeRole.PAYMENT_AUTHORIZER]),
        text: 'Pending Proformas',
        path: '/pending-proformas'
    },
    {
        visible: onRoles([EmployeeRole.MANAGING_DIRECTOR, EmployeeRole.PAYMENT_APPROVER, EmployeeRole.ACCOUNTANT, EmployeeRole.PAYMENT_AUTHORIZER, EmployeeRole.PROJECT_MANAGER, EmployeeRole.SYSTEM_ADMIN]),
        text: 'Employees',
        path: '/employees'
    },
    {
        visible: onRoles([EmployeeRole.MANAGING_DIRECTOR, EmployeeRole.PAYMENT_APPROVER, EmployeeRole.ACCOUNTANT, EmployeeRole.PAYMENT_AUTHORIZER, EmployeeRole.PROJECT_MANAGER, EmployeeRole.SYSTEM_ADMIN]),
        text: 'Projects',
        path: '/projects'
    },
    {
        visible: onRoles([EmployeeRole.MANAGING_DIRECTOR, EmployeeRole.PAYMENT_APPROVER, EmployeeRole.ACCOUNTANT, EmployeeRole.PAYMENT_AUTHORIZER, EmployeeRole.PROJECT_MANAGER]),
        text: 'Proformas',
        path: '/proformas'
    },
];

/**
 * Gets the default route for a logged-in user based on their roles
 * @param user - The logged-in user data
 * @returns The path to the default route
 */
export const getDefaultRoute = (user: LoginResponse | null): string => {
    if (!user) {
        return '/login';
    }

    // Role checking function
    const onRoles = (roles: EmployeeRole[]) => {
        if (roles.length === 0) {
            return true;
        }
        if (user.roles.length === 0) {
            return false;
        }
        return roles.some(role => user.roles.includes(role));
    };

    const menuItems = getMenuItems(onRoles);
    
    // Find the default menu item that the user has access to
    const defaultItem = menuItems.find(item => item.default && item.visible);
    
    if (defaultItem) {
        return defaultItem.path;
    }
    
    // Fallback: find the first visible menu item
    const firstVisibleItem = menuItems.find(item => item.visible);
    
    if (firstVisibleItem) {
        return firstVisibleItem.path;
    }
    
    // Final fallback
    return '/proforma';
};
